/**
 * header-custom.js
 * Externalized from sections/header.liquid inline <script> blocks.
 * Loaded with defer — DOM is fully parsed when this runs.
 *
 * Contains:
 *   1. Mobile scroll-hide header  (IIFE)
 *   2. Nav video modal            (IIFE -- defer guarantees DOM ready)
 *   3. MutationObserver auto-play (IIFE -- defer guarantees DOM ready)
 */

/* -------------------------------------------------------
   1. Mobile scroll-hide header
   ------------------------------------------------------- */
(function () {
  var header = document.querySelector('.o-header');

  if (!header) {
    return;
  }

  var scrollThreshold = 100;
  var mobileQuery = window.matchMedia('(max-width: 749px)');
  var existingBinding = window.__acosHeaderScrollBinding;
  var lastScroll = window.pageYOffset || 0;
  var scrollTicking = false;
  var isMobile = mobileQuery.matches;

  if (existingBinding) {
    window.removeEventListener('scroll', existingBinding.onScroll);

    if (typeof existingBinding.mobileQuery.removeEventListener === 'function') {
      existingBinding.mobileQuery.removeEventListener('change', existingBinding.syncMobileState);
    } else {
      existingBinding.mobileQuery.removeListener(existingBinding.syncMobileState);
    }
  }

  function syncMobileState() {
    isMobile = mobileQuery.matches;

    if (!isMobile) {
      header.classList.remove('header-hidden');
    }
  }

  function updateHeaderVisibility() {
    scrollTicking = false;

    var currentScroll = window.pageYOffset || 0;

    if (!isMobile) {
      lastScroll = currentScroll;
      return;
    }

    if (currentScroll <= scrollThreshold) {
      header.classList.remove('header-hidden');
      lastScroll = currentScroll;
      return;
    }

    if (currentScroll > lastScroll) {
      header.classList.add('header-hidden');
    } else if (currentScroll < lastScroll) {
      header.classList.remove('header-hidden');
    }

    lastScroll = currentScroll;
  }

  function onScroll() {
    if (scrollTicking) {
      return;
    }

    scrollTicking = true;
    requestAnimationFrame(updateHeaderVisibility);
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', syncMobileState);
  } else {
    mobileQuery.addListener(syncMobileState);
  }

  window.__acosHeaderScrollBinding = {
    mobileQuery: mobileQuery,
    onScroll: onScroll,
    syncMobileState: syncMobileState
  };
  syncMobileState();
})();

(function () {
  function applyHeroTextStyle(slide, state) {
    var content = slide.querySelector('.o-slideshow__slide-content');
    if (!content) return;
    var color = '#ffffff';
    content.style.setProperty('opacity', '1', 'important');
    content.style.setProperty('color', color, 'important');
    content.style.setProperty('transition', 'none', 'important');
    var textElements = Array.prototype.slice.call(content.querySelectorAll('h1, h2, h3, .o-slideshow__caption, .o-slideshow__text, p'));
    textElements.forEach(function (element) {
      element.style.setProperty('opacity', '1', 'important');
      element.style.setProperty('color', color, 'important');
      element.style.setProperty('transition', 'none', 'important');
    });
  }

  function updateHeroTextState(video) {
    var slide = video.closest('.o-slideshow__slide');
    if (!slide) return;
    var container = video.closest('.o-slideshow__slide-video');
    if (!container || window.getComputedStyle(container).display === 'none') return;

    if (window.matchMedia('(max-width: 767px)').matches) {
      slide.classList.remove('is-video-spinning', 'is-video-settling');
      applyHeroTextStyle(slide, 'initial');
      return;
    }

    slide.classList.remove('is-video-spinning', 'is-video-settling');
    applyHeroTextStyle(slide, 'initial');
  }

  function bindHeroTextVideo(video) {
    if (video.dataset.heroTextBound === '1') return;
    video.dataset.heroTextBound = '1';
    video.removeAttribute('poster');
    var host = video.closest('.js-lazy-video-host');
    if (host) {
      host.style.backgroundColor = '#ffffff';
    }
    var slide = video.closest('.o-slideshow__slide');
    if (slide) {
      slide.classList.remove('is-video-spinning', 'is-video-settling');
      applyHeroTextStyle(slide, 'initial');
    }
    ['loadedmetadata', 'play', 'playing', 'seeking', 'seeked', 'durationchange', 'ended', 'emptied'].forEach(function (eventName) {
      video.addEventListener(eventName, function () {
        updateHeroTextState(video);
      });
    });
    updateHeroTextState(video);
  }

  function scanHeroTextVideos() {
    if (!document.body.classList.contains('template-index')) return;
    document.querySelectorAll('.o-slideshow__slide-video video').forEach(bindHeroTextVideo);
  }

  window.addEventListener('load', scanHeroTextVideos, false);
  document.addEventListener('shopify:section:load', scanHeroTextVideos, false);
  new MutationObserver(scanHeroTextVideos).observe(document.documentElement, { childList: true, subtree: true });
})();

/* -------------------------------------------------------
   2. Nav video modal
   ------------------------------------------------------- */
(function () {
  function closeModal() {
    var modal = document.getElementById('navVideoModal');
    var content = document.getElementById('navVideoContent');
    if (modal) modal.classList.remove('active');
    if (content) content.innerHTML = '';
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('.nav-promo-video-trigger');
    if (t) {
      e.preventDefault();
      var c = document.getElementById('navVideoContent');
      c.innerHTML = '';
      var v = document.createElement('video');
      v.src = t.dataset.modalSrc;
      v.muted = true;
      v.autoplay = true;
      v.controls = true;
      v.playsInline = true;
      v.style.cssText = 'width:100%;height:100%;background:#000;';
      c.appendChild(v);
      document.getElementById('navVideoModal').classList.add('active');
      return;
    }
    if (e.target.closest('#navVideoClose') || e.target.id === 'navVideoOverlay') {
      closeModal();
    }
  });
})();

/* -------------------------------------------------------
   3. MutationObserver auto-play for nav videos
   ------------------------------------------------------- */
(function () {
  function hydratePromotionVideo(trigger) {
    if (!trigger || trigger.dataset.navPromoVideoHydrated === 'true') return trigger && trigger.querySelector('video');
    var template = trigger.querySelector('.js-nav-promo-video-template');
    if (!template) return trigger.querySelector('video');

    var fragment = template.content.cloneNode(true);
    var video = fragment.querySelector('video');
    if (!video) return null;

    var poster = trigger.querySelector('img');
    template.remove();
    if (poster) {
      poster.replaceWith(fragment);
    } else {
      trigger.appendChild(fragment);
    }
    trigger.dataset.navPromoVideoHydrated = 'true';
    video.muted = true;
    video.load();
    return video;
  }

  function isPromotionVisible(trigger) {
    if (!trigger || trigger.closest('[inert]') || trigger.closest('[aria-hidden="true"]')) return false;
    if (!trigger.getClientRects().length) return false;
    var style = window.getComputedStyle(trigger);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function playVisibleVideos() {
    document.querySelectorAll('.m-main-nav .nav-promo-video-trigger, .m-promotions-wrapper .nav-promo-video-trigger').forEach(function (trigger) {
      if (!isPromotionVisible(trigger)) return;
      var v = hydratePromotionVideo(trigger);
      if (!v) return;
      if (v.paused) {
        v.muted = true;
        v.play().catch(function () {});
      }
    });
  }

  var videoDebounce = null;
  var obs = new MutationObserver(function () {
    if (videoDebounce) clearTimeout(videoDebounce);
    videoDebounce = setTimeout(function () {
      playVisibleVideos();
      videoDebounce = null;
    }, 300);
  });

  document.querySelectorAll('.m-main-nav').forEach(function (el) {
    obs.observe(el, {
      attributes: true,
      subtree: true,
      attributeFilter: ['inert', 'aria-hidden', 'class', 'style']
    });
  });

  document.addEventListener('click', function (e) {
    if (
      e.target.closest('.js-nav-toggle') ||
      e.target.closest('.js-hamburger') ||
      e.target.closest('.m-header-sidebar__link')
    ) {
      setTimeout(playVisibleVideos, 400);
    }
  });

  document.addEventListener('mouseover', function (e) {
    if (!e.target.closest('.m-main-nav')) return;
    window.requestAnimationFrame(playVisibleVideos);
  }, { passive: true });

  document.addEventListener('focusin', function (e) {
    if (!e.target.closest('.m-main-nav')) return;
    window.requestAnimationFrame(playVisibleVideos);
  });

  window.addEventListener('load', playVisibleVideos, { once: true });
})();
(function () {
  var HOVERABLE = '(hover: hover) and (pointer: fine)';
  var nav = document.querySelector('.m-main-nav');
  var panels = nav && nav.querySelector('.m-main-nav__panels');
  var localization = nav && nav.querySelector('.m-main-nav__localization');
  if (!panels) return;

  function canHover() { return window.matchMedia(HOVERABLE).matches; }
  /* 테마 기본 스크립트가 패널에 박는 인라인 위치 스타일 제거 (데스크톱) */
  function stripThemeInlineStyles() {
    if (!canHover()) return;
    // 패널 묶음의 인라인 transform/left 제거
    if (panels.style.transform) panels.style.removeProperty('transform');
    if (panels.style.left) panels.style.removeProperty('left');
    // 각 패널의 인라인 transform 제거
    panels.querySelectorAll('.m-main-nav__panel').forEach(function (p) {
      if (p.style.transform) p.style.removeProperty('transform');
      if (p.style.left) p.style.removeProperty('left');
    });
    // nav 자체의 인라인 height/transform 제거
    if (nav.style.transform) nav.style.removeProperty('transform');
  }

  // 테마 스크립트가 다시 박을 때마다 지우도록 감시
  var stripObserver = new MutationObserver(stripThemeInlineStyles);
  stripObserver.observe(panels, { attributes: true, attributeFilter: ['style'], subtree: true });
  stripObserver.observe(nav, { attributes: true, attributeFilter: ['style'] });
  stripThemeInlineStyles();

  var groups = Array.prototype.slice.call(
    panels.querySelectorAll(':scope > .m-main-nav__panel-group')
  );

  function panelById(id) {
    return id ? panels.querySelector('#' + CSS.escape(id)) : null;
  }

  var FADE_MS = 450;   // CSS opacity transition 시간과 맞춤

  function closeFromLevel(level) {
    for (var i = level - 2; i < groups.length; i++) {
      var group = groups[i];
      if (!group) continue;
      group.classList.remove('is-open');   // 너비 접힘 시작 (CSS가 부드럽게 처리)

      group.querySelectorAll('.m-main-nav__panel.is-active').forEach(function (p) {
        p.classList.remove('is-active');   // 페이드아웃 시작
        // inert/aria 정리는 페이드가 끝난 뒤에 (그동안 다시 열리면 취소)
        var pending = setTimeout(function () {
          if (!p.classList.contains('is-active')) {
            p.setAttribute('inert', '');
            p.setAttribute('aria-hidden', 'true');
          }
        }, FADE_MS);
        p._fadeTimer && clearTimeout(p._fadeTimer);
        p._fadeTimer = pending;
      });
    }
    panels.querySelectorAll('.js-nav-toggle[aria-expanded="true"]').forEach(function (btn) {
      var childLevel = parseInt(btn.getAttribute('data-level'), 10) + 1;
      if (childLevel >= level) {
        btn.setAttribute('aria-expanded', 'false');
        btn.classList.remove('m-main-nav__link--cascade-open');
      }
    });
  }

  function openTarget(btn) {
    var target = panelById(btn.getAttribute('aria-controls'));
    if (!target) return;

    var childLevel = parseInt(btn.getAttribute('data-level'), 10) + 1;
    var group = target.closest('.m-main-nav__panel-group');

    closeFromLevel(childLevel + 1);   // 더 깊은 하위만 페이드로 정리

    // 같은 슬롯의 형제 패널은 즉시 제거 (페이드 없이 → 겹침 방지)
    if (group) {
      group.querySelectorAll('.m-main-nav__panel.is-active').forEach(function (sib) {
        if (sib !== target) {
          sib._fadeTimer && clearTimeout(sib._fadeTimer);
          sib.classList.remove('is-active');
          sib.setAttribute('inert', '');
          sib.setAttribute('aria-hidden', 'true');
        }
      });
      // 형제 버튼들의 열림 표시도 해제
      var siblingButtons = panels.querySelectorAll(
        '.js-nav-toggle[data-level="' + (childLevel - 1) + '"][aria-expanded="true"]'
      );
      siblingButtons.forEach(function (b) {
        if (b !== btn) {
          b.setAttribute('aria-expanded', 'false');
          b.classList.remove('m-main-nav__link--cascade-open');
        }
      });
    }

    target._fadeTimer && clearTimeout(target._fadeTimer);   // 닫힘 예약 취소
    target.classList.add('is-active');
    target.removeAttribute('inert');
    target.setAttribute('aria-hidden', 'false');
    if (group) group.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
    btn.classList.add('m-main-nav__link--cascade-open');
  }

  /* ---- hover로 자동 펼침 (닫힘은 지연으로 깜빡임 방지) ---- */
  var closeTimer = null;
  function clearCloseTimer() { if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; } }

  panels.addEventListener('pointerover', function (e) {
    if (!canHover()) return;
    var item = e.target.closest('.m-main-nav__item');
    if (!item || !panels.contains(item)) return;
    clearCloseTimer();

    var btn = item.querySelector(':scope > .js-nav-toggle');
    if (btn) {
      openTarget(btn);            // 자식 있는 항목 → 그 자식 컬럼 펼침
    } else {
      // 자식 없는 최종 링크에 올리면, 그 항목이 속한 레벨의 하위 컬럼은 닫음
      var panel = item.closest('.m-main-nav__panel');
      var lvl = panel ? parseInt(panel.getAttribute('data-level'), 10) : 1;
      closeFromLevel(lvl + 1);
    }
  });

  // 메뉴 영역을 완전히 벗어나면 잠시 후 전부 닫기
  panels.addEventListener('pointerleave', function () {
    if (!canHover()) return;
    clearCloseTimer();
    closeTimer = setTimeout(function () { closeFromLevel(2); }, 500);
  });
  panels.addEventListener('pointerenter', clearCloseTimer);

  /* 하단 국가/언어/통화 선택 영역으로 이동할 때 열린 PC 메뉴를 유지 */
  if (localization) {
    localization.addEventListener('pointerenter', clearCloseTimer);
    localization.addEventListener('pointerleave', function () {
      if (!canHover() || nav.classList.contains('m-main-nav--localization-open')) return;
      clearCloseTimer();
      closeTimer = setTimeout(function () { closeFromLevel(2); }, 500);
    });
    localization.addEventListener('focusin', clearCloseTimer);
  }

  /* ---- 클릭/키보드(포커스)로도 열 수 있게 (접근성) ---- */
  panels.addEventListener('click', function (e) {
    if (!canHover()) return;      // 터치 기기는 테마 기본 클릭 동작 그대로
    var btn = e.target.closest('.js-nav-toggle');
    if (!btn || !panels.contains(btn)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openTarget(btn);              // 자식 패널 열기 (이동은 최종 링크에서만)
  }, true);

  panels.addEventListener('focusin', function (e) {
    if (!canHover()) return;
    var btn = e.target.closest('.js-nav-toggle');
    if (btn && panels.contains(btn)) openTarget(btn);
  });
})();
/* 페이지 로드 완료 후 애니메이션 허용 (CLS 방지용) */
(function () {
  function markLoaded() {
    requestAnimationFrame(function () {
      document.documentElement.classList.add('page-loaded');
    });
  }
  if (document.readyState === 'complete') {
    markLoaded();
  } else {
    window.addEventListener('load', markLoaded, { once: true });
  }
})();
